import { motion } from 'framer-motion';
import styled from 'styled-components';

/**
 * The touch counterpart to the hover gutter: a sheet up from the bottom edge.
 *
 * A sheet rather than a popover anchored to the bubble - a bubble can be
 * anywhere on screen, including under the floating header or behind the
 * composer, and an anchored menu then needs flip-and-shift logic to stay on
 * screen. The bottom edge is always reachable by the thumb that opened it.
 */

export const Scrim = styled(motion.div)`
  position: fixed;
  inset: 0;
  z-index: 130;
  background: rgba(0, 0, 0, 0.35);
`;

export const Sheet = styled(motion.div)`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 131;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 16px 16px;
  /* Clears the home indicator on a phone without hard-coding a device. */
  padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));
  background: ${({ theme }) => theme.background};
  border-radius: 20px 20px 0 0;
  box-shadow: ${({ theme }) => theme.shadows.shadow1};
`;

/**
 * The grab handle every bottom sheet has. Decorative - the sheet is dismissed
 * by Cancel or by the scrim - but it is what makes the shape read as a sheet
 * rather than as a bar that appeared.
 */
export const SheetGrip = styled.div`
  align-self: center;
  width: 36px;
  height: 4px;
  margin-bottom: 4px;
  border-radius: 2px;
  background: ${({ theme }) => theme.mediumGray};
`;

/** What the sheet is about: one line of the message it will act on. */
export const SheetPreview = styled.div`
  padding: 0 8px 8px;
  text-align: center;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.lightGray};
  /* One line, whatever the message was. */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
